
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ProductSettingsProps {
  settings: any;
  onSettingsChange: (settings: any) => void;
}

const ProductSettings = ({ settings, onSettingsChange }: ProductSettingsProps) => {
  return (
    <div className="space-y-6">
      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-card-foreground">Inventory Management</CardTitle>
          <CardDescription className="text-admin-muted-foreground">
            Configure how your inventory is managed
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="lowStockThreshold" className="text-admin-card-foreground">Low Stock Threshold</Label>
            <Input
              id="lowStockThreshold"
              type="number"
              value={settings.lowStockThreshold || 10}
              onChange={(e) => onSettingsChange({ lowStockThreshold: parseInt(e.target.value) })}
              placeholder="10"
              className="border-admin-border"
            />
            <p className="text-xs text-admin-muted-foreground">
              Products below this quantity will be marked as low stock
            </p>
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-admin-card-foreground">Track Inventory</Label>
              <p className="text-xs text-admin-muted-foreground">
                Automatically track product quantities
              </p>
            </div>
            <Switch
              checked={settings.trackInventory !== false}
              onCheckedChange={(checked) => onSettingsChange({ trackInventory: checked })}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <Label className="text-admin-card-foreground">Allow Backorders</Label>
              <p className="text-xs text-admin-muted-foreground">
                Allow customers to order out-of-stock items
              </p>
            </div>
            <Switch
              checked={settings.allowBackorders || false}
              onCheckedChange={(checked) => onSettingsChange({ allowBackorders: checked })}
            />
          </div>
        </CardContent>
      </Card>

      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-card-foreground">Product Defaults</CardTitle>
          <CardDescription className="text-admin-muted-foreground">
            Default settings for new products
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="defaultStatus" className="text-admin-card-foreground">Default Status</Label>
            <Select
              value={settings.defaultProductStatus || "draft"}
              onValueChange={(value) => onSettingsChange({ defaultProductStatus: value })}
            >
              <SelectTrigger className="border-admin-border">
                <SelectValue placeholder="Select default status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="draft">Draft</SelectItem>
                <SelectItem value="archived">Archived</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProductSettings;
